export default __webpack_public_path__ + "a69b60ee4d03d2dd91ef83958d62bd0a.png";